import React, { useEffect, useState } from 'react';
import api from 'api/api';
import Loader from 'ui/Loader/Loader';
import NoBeneficiary from 'components/modules/Beneficiaries/NoBeneficiary/NoBeneficiary';
import BeneficiaryTable from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryTable';
import BeneficiaryRow from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryRow/BeneficiaryRow';
import BeneficiaryCol from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryCol/BeneficiaryCol';
import EditBenFab from './EditBenFab';
import { IApiBeneficiaryLocalResponse, IBeneficiaryLocal } from './BenFab.model';

enum States {
  browsing = 'browsing',
  editing = 'editing',
}

const BenFAB = () => {
  const [loadingData, setLoadingData] = useState(false);
  const [data, setData] = useState<IBeneficiaryLocal[]>([]);
  const [editData, setEditData] = useState<IBeneficiaryLocal | null>(null);

  const [state, setState] = useState<States>(States.browsing);

  const fetchBeneficiaries = () => {
    // Local Bens
    setLoadingData(true);
    api
      .get('/beneficiary/transfer?transferType=LOCAL')
      .then((response: IApiBeneficiaryLocalResponse) => {
        setData(response.beneficiaries);
      })
      .catch((error) => {
        console.error(error);
        setData([]);
      })
      .finally(() => {
        setLoadingData(false);
      });
  };

  useEffect(() => {
    fetchBeneficiaries();
  }, []);

  const openEditForm = (e: React.MouseEvent<HTMLDivElement>) => {
    setState(States.editing);
    const object = data.find(({ id }) => id === Number(e.currentTarget.id));
    if (object) {
      setEditData(object);
    }
  };

  const closeEditForm = () => {
    setState(States.browsing);
    fetchBeneficiaries();
  };

  if (state === States.editing && editData) {
    return <EditBenFab data={editData} onClose={closeEditForm} />;
  }

  const renderTable = () => (
    <BeneficiaryTable>
      {data.map((beneficiary) => (
        <BeneficiaryRow onClick={openEditForm} id={String(beneficiary.id)} key={beneficiary.id}>
          <BeneficiaryCol label="Full Name" value={beneficiary.name} width="30%" minWidth="250px" />
          <BeneficiaryCol label="Account Number" value={beneficiary.accountNumber} width="70%" minWidth="400px" />
        </BeneficiaryRow>
      ))}
    </BeneficiaryTable>
  );

  return (
    <>
      {loadingData && <Loader fullHeight />}
      {!loadingData && data.length === 0 && <NoBeneficiary />}
      {!loadingData && data.length > 0 && renderTable()}
    </>
  );
};

export default BenFAB;
